import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { APPLICATIONS_DETAILS, SpecialistServicePath } from "utils/constants";
import { Button } from "react-admin";

const DetailsButton = ({ rec, label = " " }) => {
  const navigate = useNavigate();
  return (
    <Button
      label={label}
      startIcon={<VisibilityIcon />}
      onClick={() =>
        navigate(`/${SpecialistServicePath}${APPLICATIONS_DETAILS}`, {
          state: { campaignId: rec?.campaignId, applicationId: rec?.id },
        })
      }
    />
  );
};
export default DetailsButton;
